import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSuperUser } from '../../api.context';
import {
    BookingsService,
    type CreateBookingRes1Dto,
    type CreateBookingResDto,
    type CreatePackageBookingsReqDto,
} from '../../generated';
import type { CustomMutationOptions } from '../common.types';

export const useCreatePackageBooking = (
    options?: CustomMutationOptions<
        CreatePackageBookingsReqDto,
        Array<CreateBookingResDto | CreateBookingRes1Dto>
    >
) => {
    const queryClient = useQueryClient();
    const superUser = useSuperUser();

    return useMutation({
        mutationFn: async body => {
            const response = await BookingsService.createPackageBookings({
                body,
                query: superUser ? { superuser: superUser } : {},
            });

            queryClient.invalidateQueries({
                queryKey: ['useOrdersLazyKey', {}],
                exact: true,
                refetchType: 'active',
            });

            if (!response.data) throw new Error('Error');

            return response.data;
        },
        ...options,
    });
};
